import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types'
import { Box, CircularProgress, TableCell, TextField, Tooltip, Typography } from '@mui/material';

import { renderSuccessMessage, renderErrorMessage } from '../../../lib/toastMessage';
import Logger from '../../../lib/Logger';

import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { PaginationTable } from './paginationTable';
import { LoadingButton } from '@mui/lab';
import { axiosPostCall } from 'src/services/apisCall';
// import { axiosVBGetCall } from '../../../services/vbApiCall';
import dayjs from 'dayjs';

const BasicDatePicker = ({ value, onChange }) => {
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} >
            <DatePicker
                slotProps={{
                    textField: { size: 'small' }, actionBar: {
                        actions: ['today', 'clear'],
                    },
                }}
                sx={{ width: "270px", margin: "8px" }}
                value={value} onChange={(newValue) => onChange(newValue)}

            />
        </LocalizationProvider>
    )
}

BasicDatePicker.propTypes = {
    value: propTypes.number,
    onChange: propTypes.func.isRequired,
}

export const TtsPlanTable = ({ user = {}, forceLoad, ttsData, loading: tableLoading }) => {

    const [rows, setRows] = useState(ttsData)
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)

    const logger = new Logger("senderId");

    const handleUpdateCredits = async (plan, credit, validity, setLoading, type) => {

        setLoading(true);

        try {
            if (credit === 0) {
                setLoading(false);
                return renderErrorMessage("Credit should be more than 0.")
            }
            const { ttsType } = plan;
            const { voiceInfo: { userId } } = user;

            if (ttsType && userId && type) {
                const params = { assignTo: userId, creditType: ttsType, credit, type, assignValidity: validity }
                const { message } = await axiosPostCall("assignTTSCreditToVoiceUser", params);

                forceLoad();
                renderSuccessMessage(message);
            }

        } catch (error) {
            logger.error("ttsPlanTable.jsx ,handleUpdateCredits ,assignTTSCreditToUser api", error);
            renderErrorMessage(error?.message);
        }

        setLoading(false);

    }

    useEffect(() => {
        setRows(ttsData)
    }, [ttsData])

    const columns = [
        { id: 'ttsType', label: 'TTS Type', minWidth: 50, align: "center" },
        // {
        //     id: 'allowCountry',
        //     label: 'Country Code',
        //     minWidth: 80,
        //     align: 'center',
        // },
        { id: 'TotBal', label: 'Total Character', minWidth: 125, align: "center" },
        { id: 'CurrBal', label: 'Remaining Character', minWidth: 125, align: "center" },
        { id: 'Validity', label: 'Validity', minWidth: 100, align: "center" },
        {
            id: 'actions',
            label: 'Action',
            minWidth: 200,
            align: 'center',
        }
    ];

    const ActionJsx = ({ id, align, value, row }) => {

        const [creditValue, setCreditValue] = useState(0);
        const [assignLoading, setAssignLoading] = useState(false);
        const [deductLoading, setDeductLoading] = useState(false);
        const [validity, setValidity] = useState(row.validity);

        return (
            <TableCell
                key={id}
                align={align}
                sx={{
                    color: 'grey.400',
                    borderBottom: '0.5px dashed',
                    borderColor: 'grey.700',
                }}>
                               <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 1 }}>
               
               
                                   <LocalizationProvider dateAdapter={AdapterDayjs}>
                                       <DatePicker
                                           label="Validity"
                                           value={validity ? dayjs.unix(validity) : null}
                                           onChange={(newValue) =>
                                               setValidity(newValue ? newValue.startOf("day").unix() : null)
                                           }
                                           shouldDisableDate={(date) =>
                                               dayjs(date).isBefore(dayjs().startOf("day"))
                                           }
                                           slotProps={{
                                               textField: {
                                                   size: "small",
                                                   sx: {
                                                       width: "180px",
                                                   },
                                               },
                                           }}
                                       />
                                   </LocalizationProvider>

                    <TextField id="outlined-basic" type='number' label="Credits" value={creditValue} onChange={(e) => setCreditValue(e.target.value)} size='small' variant="outlined" sx={{ width: "150px" }} />

                    <Box sx={{ ml: '6px' }}>

                        <Tooltip title="Add Credit">

                            <LoadingButton
                                sx={{
                                    width: '30px',
                                    minWidth: '30px',
                                    borderRadius: '50%'
                                }}
                                size="small"
                                color='primary'
                                onClick={() => handleUpdateCredits(row, creditValue, validity, setAssignLoading, "A")}
                                loading={assignLoading}
                                loadingIndicator={<CircularProgress style={{ color: '#22C55E' }} size={16} />}
                            >

                                <AddCircleIcon />
                            </LoadingButton>
                        </Tooltip >
                        <Tooltip title="Deduct Credit">

                            <LoadingButton
                                style={{
                                    width: '30px',
                                    minWidth: '30px',
                                    borderRadius: '50%'
                                }}
                                size="small" color='error' loading={deductLoading}
                                onClick={() => handleUpdateCredits(row, creditValue, validity, setDeductLoading, "D")}
                                loadingIndicator={<CircularProgress style={{ color: '#FF5630' }} size={16} />}
                            >
                                <RemoveCircleIcon />
                            </LoadingButton>
                        </Tooltip>
                    </Box>
                    {/* <Tooltip title="Remove Plan">
                        <LoadingButton
                            style={{
                                width: '30px',
                                minWidth: '30px'
                            }}
                            size="small" sx={{ color: "red", }} loading={removePlanLoading}
                            loadingIndicator={<CircularProgress style={{ color: 'red' }} size={16} />}
                            onClick={() => handleRemovePlan(row, setRemovePlanLoading)}

                        >
                            <DeleteIcon />
                        </LoadingButton>

                    </Tooltip> */}

                </Box>
            </TableCell>
        )
    }

    return (
        <Box>
            <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                sx={{ mb: "-20px" }}
            >
                TTS Plan
            </Typography>
            <PaginationTable
                page={page}
                ActionJsx={ActionJsx}
                setPage={setPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                loading={tableLoading}
                rows={rows}
                columns={columns}
                maxHeight={680}
                mapKey="ttsType"
            />
        </Box>

    )
}

TtsPlanTable.propTypes = {
    campaignId: propTypes.number,
}
